import React, { createContext } from 'react';
import classNames from 'classnames';
import { Button, Dialog, DialogProps, SvgIcon } from '@fx-ui/fine-design';
import { isFunction } from '@libs/shared';
import useDialogFullScreen from './useDialogFullScreen';
import ContractIcon from '../../assets/svgicons/contract.svg';
import ExpandIcon from '../../assets/svgicons/expand.svg';

export const FullScreenDialogContext = createContext<{ fullscreen: boolean }>({
    fullscreen: false
});

interface IFullScreenDialogProps extends Omit<DialogProps, 'headerRight' | 'children'> {
    children?: React.ReactNode;
}

type FullScreenDialogComponent = React.FC<IFullScreenDialogProps> & {
    Context: typeof FullScreenDialogContext;
};

const FullScreenDialog: FullScreenDialogComponent = (props: IFullScreenDialogProps) => {
    const { className, children, ...otherProps } = props;
    const { getFullScreenState, getDialogClassName, onClick } = useDialogFullScreen();
    const fullscreen = getFullScreenState();

    const childNode = isFunction(children) ? children(fullscreen) : children;

    return (
        <Dialog
            {...otherProps}
            className={classNames(className, getDialogClassName())}
            headerRight={
                <Button
                    className="fx-full-screen-btn"
                    type="text-normal"
                    size="small"
                    icon={<SvgIcon component={fullscreen ? ContractIcon : ExpandIcon} />}
                    onClick={onClick}
                />
            }
        >
            <FullScreenDialogContext.Provider value={{ fullscreen }}>
                {childNode}
            </FullScreenDialogContext.Provider>
        </Dialog>
    );
};

FullScreenDialog.Context = FullScreenDialogContext;

export default FullScreenDialog;
